export default __webpack_public_path__ + "static/eric-0e26b035556378a8fba1cd25b7baf943.jpg";